<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col-md-6 text-right">
                              <router-link :to="'/'+$i18n.locale+'/add_member'" class="text-light">
                                <base-button type="primary" size="md">{{$t('add')}}</base-button>
                              </router-link>
        </div>
        <div class="col-md-4" style="padding:30px">
                                            <base-input :name="$t('search')" class=""
                                                        required
                                                        :placeholder="$t('search')"
                                                        style="margin-top: 50px;max-width: 300px;"
                                                        v-model="form.search">
                                            </base-input>
                                            <base-button type="primary" @click="onSearch('')" size="md">{{$t('search')}}</base-button>
        </div>
          <div class="col-md-8 text-right" style="padding:10px"> 
          <span style="margin-right:20px">{{$t('status')}}</span>
          <base-button style="margin:5px" type="info" @click="onSearch('')" size="md">{{$t('all')}}</base-button>
          <base-button style="margin:5px" type="warning" @click="onSearch('new')" size="md">{{$t('new')}}</base-button>
          <base-button style="margin:5px" type="primary" @click="onSearch('active')" size="md">{{$t('active')}}</base-button>
          <base-button style="margin:5px" type="danger" @click="onSearch('expired')" size="md">{{$t('expired')}}</base-button>
          <base-button style="margin:5px" type="light" @click="onSearch('disabled')" size="md">{{$t('disabled')}}</base-button>
        </div>
      </div>
      
    </div>

    <div class="table-responsive">

      <!-- <div class="overflow-auto">
        <b-table
          id="member-table"
          :items="tableData"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template slot="img" slot-scope="row">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img :src="row.item.img">
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.item.title}}</span>
              </div>
            </div>
          </template>
        </b-table>

        <div class="card-footer d-flex justify-content-end bg-transparent">
              <b-pagination
                size="lg"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="member-table"
              ></b-pagination>
        </div>

      </div> -->

      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="show_item">
        <template slot="columns">
          <!-- <th></th> -->
          <th>{{$t('first_name')}} {{$t('last_name')}}</th>
          <th>{{$t('nickname')}}</th>
          <th>{{$t('gender')}}</th>
          <th>{{$t('phone')}}</th>
          <th>{{$t('status')}}</th>
          <th>{{$t('expired_at')}}</th>
          <th>{{$t('left_day')}}</th>
          <!-- <th></th> -->
        </template>

        <template slot-scope="{row}">
          <!-- <td>
            <div class="media align-items-center">
                <img v-if="row.img !== ''" :src="row.img">
                <img v-if="!row.img" width="150px" src="/img/noimage.png">
            </div>
          </td> -->
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
                  <span style="color:#525f7f" class="name mb-0 text-sm">{{row.firstname}} {{row.lastname}}</span>
                </router-link>
              </div>
            </div>
          </th>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
              <span style="color:#525f7f">{{row.nickname}}</span>
            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
              <div v-if="row.gender === 'male'"><span style="color:#525f7f">{{$t('male')}}</span></div>
              <div v-if="row.gender === 'female'"><span style="color:#525f7f">{{$t('female')}}</span></div>
            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
              <span style="color:#525f7f">{{row.phone}}</span>
            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">

              <span v-if="row.status === 'new'" style="color:#525f7f">{{$t('new')}}</span>
              <span v-if="row.status === 'active'" style="color:#525f7f">{{$t('active')}}</span>
              <span v-if="row.status === 'disabled'" style="color:#525f7f">{{$t('disabled')}}</span>
              <span v-if="row.status === 'expired'" style="color:#525f7f">{{$t('expired')}}</span>

            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
              <span style="color:#525f7f">{{ row.expired_at | luxon }}</span>
            </router-link>
          </td>
          <td>
            <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
              <span style="color:#525f7f">{{ row.lett_days }}</span>
            </router-link>
          </td>

          <!-- <td class="text-right">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
                  <span class="dropdown-item">{{$t('edit')}}</span>
                </router-link>
                <router-link :to="'/'+$i18n.locale+'/edit_member?id='+row._id" class="text-light">
                  <span class="dropdown-item">{{$t('member_image')}}</span>
                </router-link>
                <router-link :to="'/'+$i18n.locale+'/member_payment?id='+row._id" class="text-light">
                  <span class="dropdown-item">{{$t('member_payment')}}</span>
                </router-link>
                <span @click="modal_confirm = true" style="cursor:pointer" class="dropdown-item">{{$t('delete')}}</span>
              </template>
            </base-dropdown>
          </td> -->

          <modal :show.sync="modal_confirm">

            <p>{{$t('confirm_delete')}}</p>

            <template slot="footer">
                <base-button @click="modal_confirm = false" type="primary">{{$t('cancel')}}</base-button>
                <base-button @click="DeleteMember(row._id)" type="danger">{{$t('delete')}}</base-button>
            </template>

          </modal>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
         <div @click="ListItem()">
          <base-pagination v-model="page" :perPage="show_page.limit" :total="show_page.total" :pageCount="show_page.total" size="lg"></base-pagination>
         </div>
    </div>

    <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>

  </div>
</template>
<script>
var moment = require('moment'); // require
moment().format(); 
import i18n from "@/i18n"
  export default {
    name: 'members-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_confirm: false,
        show_item: [],
        show_page: [],
        search: this.$route.query.search,
        status: this.$route.query.status,
        limit: 10,
        page: 1,
        form: {
          search: ''
        },
        diff: ''
        // perPage: 3,
        // currentPage: 1,
        /* tableData: [
          {
            img: '/img/theme/bootstrap.jpg',
            title: 'Argon Design System',
            budget: '$2500 USD',
            status: 'pending',
            statusType: 'warning',
            completion: 60
          },
          {
            img: '/img/theme/angular.jpg',
            title: 'Angular Now UI Kit PRO',
            budget: '$1800 USD',
            status: 'completed',
            statusType: 'success',
            completion: 100
          },
          {
            img: '/img/theme/sketch.jpg',
            title: 'Black Dashboard',
            budget: '$3150 USD',
            status: 'delayed',
            statusType: 'danger',
            completion: 72
          },
          {
            img: '/img/theme/react.jpg',
            title: 'React Material Dashboard',
            budget: '$4400 USD',
            status: 'on schedule',
            statusType: 'info',
            completion: 90
          },
          {
            img: '/img/theme/vue.jpg',
            title: 'Vue Paper UI Kit PRO',
            budget: '$2200 USD',
            status: 'completed',
            statusType: 'success',
            completion: 100
          }
        ] */
      }
    },
    computed: {
      rows() {
          return this.show_item.length
      }
    },
    created () {
      this.ListItem()
    },
    watch: {
        '$route': function(){
          this.search = this.$route.query.search,
          this.status = this.$route.query.status,
          setTimeout(() => {
            this.ListItem();
          }, 1000)
        }
    },
    methods: {
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
      },
      ListItem () {
        var status_url = ''
        if (this.search === undefined) {
          this.search = ''
        }
        if (this.status === "")
        {
          status_url = ''
        }
        if (this.status === "new")
        {
          status_url = '&status=new'
        }
        if (this.status === "active")
        {
          status_url = '&status=active'
        }
        if (this.status === "disabled")
        {
          status_url = '&status=disabled'
        }
        if (this.status === "expired")
        {
          status_url = '&status=expired'
        }
        this.show_item = []
        this.page = this.page-1
        this.$http.get('members?search='+this.search+'&limit='+this.limit+'&page='+this.page+status_url)
          .then(request => this.ListItemSuccessful(request))
          .catch(() => this.ListItemFailed())
        this.page = this.page+1
      },
      ListItemSuccessful (req) {
        if (req.data.code !== '0') {
          this.ListItemFailed(req)
          return
        }
        for (var i = 0, l = req.data.data.data.length; i < l; i++) {
          this.show_item.push(req.data.data.data[i])
          // new Date().toISOString()
          // alert(this.show_item[i].expired_at)
          // alert(new Date().toISOString())
          let B = moment(new Date().toISOString());
          let A = moment(this.show_item[i].expired_at);
          this.show_item[i].lett_days = A.diff(B, 'days')
          // alert(A.diff(B, 'days'));// => 1
        }
        this.show_page = req.data.data.pagination

        
      },
      ListItemFailed (req) {
        this.modalAlert(req)
      },
      DeleteMember (id) {
        this.modal_confirm = false
        this.$http.delete('members/'+id)
          .then(request => this.DeleteMemberSuccessful(request))
          .catch(() => this.DeleteMemberFailed())
      },
      DeleteMemberSuccessful (req) {
        if (req.data.code !== '0') {
          this.DeleteMemberFailed(req)
          return
        }
        this.ListItem()
      },
      DeleteMemberFailed (req) {
        this.modalAlert(req)
      },
      onSearch (sta) {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/member?search='+this.form.search+'&status='+sta)
            this.limit = 10
            this.page = 1
        }
    }
  }
</script>
<style>
</style>
